import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Pages/home';
import Properties_listing from './Pages/Properties_listing';
import Propertydetails from './Pages/Propertydetails';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/properties" element={<Properties_listing />} />
         <Route path="/details" element={<Propertydetails />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;